/**
 * GET `admin/dashboard/trends?months=N` — тренды по месяцам: MRR (сомы),
 * активные клиенты (соло/клиника), заявки → клиенты, текущий срез
 * соло/клиника. Gateway говорит camelCase — конверсию глушим. Без BE — мок.
 */

import {apiEnabled, http} from '@services/utils';

import {DASHBOARD_TRENDS} from '../mocks';
import type {DashboardTrends} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

type Raw = Record<string, unknown>;

const asObj = (v: unknown): Raw => (typeof v === 'object' && v !== null ? (v as Raw) : {});
const asNum = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0);
const asStr = (v: unknown): string => (typeof v === 'string' ? v : '');
const arr = (v: unknown): unknown[] => (Array.isArray(v) ? v : []);

export const getTrends = async (months = 6): Promise<DashboardTrends> => {
  if (!apiEnabled) {
    await sleep(300);
    return structuredClone(DASHBOARD_TRENDS);
  }

  const raw = await http<Raw>('admin/dashboard/trends', {
    params: {months: String(months)},
    skipCaseConversion: true,
  });
  const ratio = asObj(raw.soloClinicRatio);
  return {
    mrr: arr(raw.mrr).map((p) => {
      const r = asObj(p);
      return {month: asStr(r.month), value: asNum(r.value)};
    }),
    activeClients: arr(raw.activeClients).map((p) => {
      const r = asObj(p);
      return {month: asStr(r.month), solo: asNum(r.solo), clinic: asNum(r.clinic)};
    }),
    leadsToClients: arr(raw.leadsToClients).map((p) => {
      const r = asObj(p);
      return {month: asStr(r.month), leads: asNum(r.leads), clients: asNum(r.clients)};
    }),
    soloClinicRatio: {solo: asNum(ratio.solo), clinic: asNum(ratio.clinic)},
  };
};
